import React from 'react';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import TextField from '../../../../components/form/text-field/text-field';
import FormSelectField from '../../../../components/form/select-field';
import {
  SERVICE_TERM_RENTAL_RADIO_BUTTON,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_ONEOFF,
} from '../../../../app-constants';
import './device-item.css';

const DeviceItem = (props) => {
  const {
    deviceKey,
    deviceName,
    linkURL,
    linkText,
    deviceToolTipText,
    readOnlyQuantity,
    deviceToolTipImagePath,
    unitPricePurchaseValue,
    unitPriceRentalValue,
    unitPriceSuffixText,
    serviceTermSelectedOption,
    quantityValue,
    quantityInputOnChange,
    quantityInputOnBlur,
    quantityMin,
    paymentType,
    labels,
    emptyDeviceQuantityData,
    bsipItem,
    bsipUnitPriceSuffixText,
    unitPriceTextOverride,
    showDropDownInQuantity,
    dropDownContent,
    isEnterpriseTrunkForSiteSelected,
  } = props;

  const decimalPlaces = amount => (Number.isInteger(amount) ? amount : amount.toFixed(2));

  const hideDevice = () => {
    if (bsipItem && readOnlyQuantity && quantityValue === 0) {
      return true;
    } else if (!bsipItem && readOnlyQuantity && quantityValue === 0) {
      return true;
    } else if (isEnterpriseTrunkForSiteSelected) {
      return true;
    }
    return false;
  };

  const getUnitPriceText = () => {
    if (bsipItem && unitPriceTextOverride) {
      return bsipUnitPriceSuffixText;
    } else if (bsipItem) {
      return `${unitPriceRentalValue}${bsipUnitPriceSuffixText !== undefined ? bsipUnitPriceSuffixText : ''}`;
    }
    return unitPriceRentalValue;
  };

  const deviceToolTipContent = () => (
    <React.Fragment>
      <img src={deviceToolTipImagePath} className="img-fluid" alt="" />
      <p className="tool-tip-text">{deviceToolTipText}</p>
    </React.Fragment>
  );

  return (
    <div className={`device-item ${hideDevice() ? 'd-none' : ''}`}>
      <div className="row">
        <div className="col-3 pl-sm-0">
          <div className="mobile-device-heading">{labels.device}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id={`id-header-${deviceKey}-tooltip-mobile`}
              toolTipText={labels.toolTip}
            />
          </div>
          <div className="item-title">{linkURL && <a href={linkURL} target="_blank" rel="noopener noreferrer">{linkText}</a>} {deviceName}
            {deviceToolTipImagePath && <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id={`id-${deviceKey}-img-tooltip`}
              Content={deviceToolTipContent}
            />
            }
            {deviceToolTipText && !deviceToolTipImagePath && <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id={`id-${deviceKey}-text-tooltip`}
              toolTipText={deviceToolTipText}
            />
            }
          </div>
        </div>
        <div className="col-3">
          <p className="mobile-device-heading">{labels.unit}</p>
          ${!bsipItem && ((paymentType === PAYMENT_TYPE_MONTHLY ||
            (serviceTermSelectedOption === SERVICE_TERM_RENTAL_RADIO_BUTTON && paymentType !== PAYMENT_TYPE_ONEOFF)) ?
            unitPriceRentalValue + unitPriceSuffixText : unitPricePurchaseValue) }
          {bsipItem && getUnitPriceText()}
        </div>
        <div className="col-4">
          <p className="mobile-device-heading">{labels.quantity}</p>
          { !readOnlyQuantity && !showDropDownInQuantity &&
          <TextField
            id={`${deviceKey}-quantity`}
            value={quantityValue === 0 ? emptyDeviceQuantityData : quantityValue}
            placeholder={quantityMin}
            onChange={quantityInputOnChange}
            onBlur={quantityInputOnBlur}
          />}
          { !readOnlyQuantity && showDropDownInQuantity &&
          <FormSelectField
            id={`${deviceKey}-quantity`}
            label=""
            disabled={false}
            options={dropDownContent.options}
            value={quantityValue}
            placeholder=""
            onBlur={quantityInputOnBlur}
            initialValuePresent
          />}
          { readOnlyQuantity && <span>{quantityValue}</span>}
        </div>
        <div className="col-2">
          <p className="mobile-device-heading">{labels.price}</p>
          $
          {!bsipItem && (
            (serviceTermSelectedOption === SERVICE_TERM_RENTAL_RADIO_BUTTON && paymentType !== PAYMENT_TYPE_ONEOFF) ||
              paymentType === PAYMENT_TYPE_MONTHLY ?
              decimalPlaces(unitPriceRentalValue * (quantityValue !== 0 && quantityValue !== undefined ? quantityValue : 0)) :
              decimalPlaces(unitPricePurchaseValue * (quantityValue !== 0 && quantityValue !== undefined ? quantityValue : 0))
          )}
          {bsipItem &&
            decimalPlaces(unitPriceRentalValue * (quantityValue !== 0 && quantityValue !== undefined ? quantityValue : 0))
          }
          {(paymentType === PAYMENT_TYPE_MONTHLY || bsipItem) && unitPriceSuffixText}
          {(paymentType === '' && serviceTermSelectedOption === SERVICE_TERM_RENTAL_RADIO_BUTTON && !bsipItem) && unitPriceSuffixText}
        </div>
      </div>
    </div>
  );
};

export default DeviceItem;
